<template lang="pug">
    .category-post
        component(:is="view")
        CategoryPagination(
            :younger="younger"
            :older="older"
        )
</template>

<script>

import { get } from 'lodash'
import { mapGetters } from 'vuex'

import ContentPage from '@/views/ContentPage'
import CategoryPagination from '@/components/CategoryPosts/Partials/Pagination'

export default {
    name: 'CategoryPost',
    components: {
        ContentPage,
        CategoryPagination
    },
    computed: {
        older() {
            return get(this.currentPage, 'older', false)
        },
        younger() {
            return get(this.currentPage, 'younger', false)
        },
        ...mapGetters({
            view: 'currentPage/view',
            currentPage: 'currentPage/page'
        })
    }
}

</script>

<style lang="sass" scoped></style>
